'use client';

import { cn } from '@/lib/utils';
import { ChevronDown, Dot } from 'lucide-react';
import { DOMAttributes, useRef, useState } from 'react';
import { DeepThinkStatus, TaskAgent } from '@/type/chat';
import '@/styles/animations.css';
import { startCase } from 'lodash';
import ThinkTasks from './ThinkTasks';
import { Collapse } from '@mui/material';
import TaskProgressAnimation from './TaskProgressAnimation';
import ScrollingBroadcast from './ScrollingBroadcast';
import { useTranslation } from '@/lib/i18n';
import ThinkTaskCard from './ThinkTasks';

interface TaskPlan {
  list: TaskAgent[];
  agent?: TaskAgent;
  agentStatus?: Record<string, 'doing' | 'done' | 'waiting' | 'error'>;
  onSelected: (agent: TaskAgent) => void;

  thinkRecord: Record<string, DeepThinkStatus[]> | undefined;
}

export default function ThinkTaskCardList({
  list,
  onSelected,
  agent,
  agentStatus,
  thinkRecord,
}: TaskPlan) {
  return (
    <div className="relative w-full">
      {list.map((item) => (
        <ThinkTaskCard
          key={item.subagent_type}
          title={item.subagent_type}
          active={item.subagent_type === agent?.subagent_type}
          status={agentStatus?.[item.subagent_type] ? agentStatus[item.subagent_type] : 'waiting'}
          onClick={() => {
            if (agentStatus?.[item.subagent_type] !== 'waiting') onSelected(item);
          }}
          thinkStatus={thinkRecord?.[item.subagent_type] ?? []}
        />
      ))}
      {/* {list.length === 1 && <AgentPlaceHolder />} */}
    </div>
  );
}

export function AgentPlaceHolder() {
  return (
    <>
      {[1, 2, 3, 4, 5, 6].map((item) => (
        <div
          className="h-[70px] flex flex-col justify-center border-t dark:border-[#1E1E1E] border-[#EFEFEF] px-6"
          key={item}
        >
          <div className="flex flex-col gap-1">
            <div className="bg-bg-main h-5 rounded-[4px] w-[50%]"></div>
            <div className="bg-bg-main h-3 rounded-[4px] w-[30%]"></div>
          </div>
        </div>
      ))}
    </>
  );
}
